// import React, { useState } from "react";
// import {
//   GoogleMap,
//   Polygon,
//   Marker,
//   Polyline,
//   useLoadScript,
// } from "@react-google-maps/api";

// const containerStyle = {
//   width: "100%",
//   height: "300px",
// };

// const polylineOptions = {
//   strokeColor: "#0000FF", // Blue line color
//   strokeOpacity: 0.8,
//   strokeWeight: 2,
// };

// const MapComponent = ({ coordinates }) => {
//   const { isLoaded } = useLoadScript({
//     googleMapsApiKey: "AIzaSyABE5oLDQJp-iEBTdd1QdTi0J8io3ufq6o",
//     id: "script-loader",
//     language: "en",
//     region: "us",
//   });

//   if (!isLoaded) return <div>Loading Map...</div>;

//   const polygonPath = JSON.parse(coordinates).map((coord) => ({
//     lat: coord.latitude,
//     lng: coord.longitude,
//   }));

//   console.log("polygonPath",polygonPath);

//   return (
//     <GoogleMap
//       mapContainerStyle={containerStyle}
//       center={polygonPath[0]}
//       zoom={15}
//       mapTypeId="satellite"
//       fillColor="#00FF00"
//     >
//       <Polygon
//         path={polygonPath}
//         options={{
//           fillColor: "#FF0000", // Red color for the fill
//           fillOpacity: 0.6, // 60% opacity
//           strokeColor: "#FF0000", // Red border
//           strokeOpacity: 0.8,
//           strokeWeight: 2,
//         }}
//       />
//       {polygonPath?.map((coord, index) => (
//         <Marker
//           key={index}
//           position={coord}
//           label={(index + 1).toString()}
//         />
//       ))}
//       <Polyline path={polygonPath} options={polylineOptions} />
//     </GoogleMap>
//   );
// };
// export default MapComponent;

// import React from "react";
// import {
//   GoogleMap,
//   Polygon,
//   Polyline,
//   useLoadScript,
// } from "@react-google-maps/api";

// const containerStyle = {
//   width: "100%",
//   height: "300px",
// };

// const polylineOptions = {
//   strokeColor: "#0000FF",
//   strokeOpacity: 0.8,
//   strokeWeight: 2,
// };

// const MapComponent = ({ coordinates }) => {
//   const { isLoaded } = useLoadScript({
//     googleMapsApiKey: "AIzaSyABE5oLDQJp-iEBTdd1QdTi0J8io3ufq6o",
//     libraries: ["marker"],
//     async: true,
//   });

//   if (!isLoaded) return <div>Loading Map...</div>;

//   const polygonPath = JSON.parse(coordinates).map((coord) => ({
//     lat: coord.latitude,
//     lng: coord.longitude,
//   }));

//   const renderMarkers = (map) => {
//     polygonPath.forEach((coord, index) => {
//       // Create a DOM element for the custom content
//       const markerContainer = document.createElement("div");
//       markerContainer.style.width = "24px";
//       markerContainer.style.height = "24px";
//       markerContainer.style.backgroundColor = "#f9c74f"; // Background color for the pin
//       markerContainer.style.borderRadius = "50%";
//       markerContainer.style.boxShadow = "0 2px 6px rgba(0, 0, 0, 0.3)";
//       markerContainer.style.border = "2px solid #000";

//       new window.google.maps.marker.AdvancedMarkerElement({
//         position: coord,
//         map,
//         content: markerContainer, // Pass the DOM node as content
//       });
//     });
//   };

//   return (
//     <GoogleMap
//       mapContainerStyle={containerStyle}
//       center={polygonPath.length ? polygonPath[0] : { lat: 0, lng: 0 }}
//       zoom={15}
//       // mapTypeId="satellite"
//       onLoad={(map) => renderMarkers(map)}
//       options={{
//         mapId: "4504f8b37365c3d0",
//         mapTypeId: "satellite",
//       }}
//     >
//       <Polygon
//         path={polygonPath}
//         options={{
//           fillColor: "#FF0000",
//           fillOpacity: 0.6,
//           strokeColor: "#FF0000",
//           strokeOpacity: 0.8,
//           strokeWeight: 2,
//         }}
//       />
//       <Polyline path={polygonPath} options={polylineOptions} />
//     </GoogleMap>
//   );
// };

// export default MapComponent;


import React from "react";
import {
  GoogleMap,
  Polygon,
  Polyline,
  useLoadScript,
} from "@react-google-maps/api";

const containerStyle = {
  width: "100%",
  height: "300px",
};

const polylineOptions = {
  strokeColor: "#0000FF",
  strokeOpacity: 0.8,
  strokeWeight: 2,
};

const MapComponent = ({ coordinates }) => {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: "AIzaSyABE5oLDQJp-iEBTdd1QdTi0J8io3ufq6o",
    libraries: ["marker"],
    async: true,
  });

  if (!isLoaded) return <div>Loading Map...</div>;

  const polygonPath = JSON.parse(coordinates).map((coord) => ({
    lat: coord.latitude,
    lng: coord.longitude,
  }));

  const renderMarkers = (map) => {
    polygonPath.forEach((coord) => {
      new window.google.maps.Marker({
        position: coord,
        map,
        icon: {
          url: "https://maps.google.com/mapfiles/ms/icons/red-dot.png", 
          scaledSize: new window.google.maps.Size(30, 30), // Adjust size
        },
      });
    });
  };

  return (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={polygonPath.length ? polygonPath[0] : { lat: 0, lng: 0 }}
      zoom={15}
      onLoad={(map) => renderMarkers(map)}
      options={{
        mapId: "4504f8b37365c3d0",
        mapTypeId: "satellite",
      }}
    >
      <Polygon
        path={polygonPath}
        options={{
          fillColor: "#FF0000",
          fillOpacity: 0.6,
          strokeColor: "#FF0000",
          strokeOpacity: 0.8,
          strokeWeight: 2,
        }}
      />
      <Polyline path={polygonPath} options={polylineOptions} />
    </GoogleMap>
  );
};

export default MapComponent;

